var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formConf
    ? _c(
        "el-row",
        {
          staticClass: "center-board_row",
          attrs: { gutter: _vm.formConf.gutter },
        },
        [
          _vm.formConf.type == 4
            ? _c("div", { staticClass: "evaluation-total-score" }, [
                _c("div", { staticClass: "total-scpre-title" }, [
                  _vm._v("总分"),
                ]),
                _c("div", { staticClass: "total-score" }, [
                  _vm._v(" " + _vm._s(_vm.totalScore) + " "),
                ]),
              ])
            : _vm._e(),
          _c(
            "el-row",
            {
              staticClass: "center-name-box",
              attrs: { align: "middle", justify: "center", type: "flex" },
            },
            [
              _c(
                "el-col",
                { staticClass: "text-center", attrs: { span: 21 } },
                [
                  _c("dt-tinymce", {
                    attrs: { inline: true },
                    on: {
                      change: function ($event) {
                        return _vm.saveProjectInfo()
                      },
                    },
                    model: {
                      value: _vm.formConf.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.formConf, "title", $$v)
                      },
                      expression: "formConf.title",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticClass: "center-desc-box",
              attrs: { align: "middle", justify: "center", type: "flex" },
            },
            [
              _c("el-col", { attrs: { span: 21 } }, [
                _c(
                  "div",
                  { staticClass: "hide-tinymce", attrs: { id: "description" } },
                  [
                    _c("el-input", {
                      ref: "description",
                      attrs: { type: "textarea", autosize: { minRows: 4 } },
                      on: {
                        change: function ($event) {
                          return _vm.saveProjectInfo()
                        },
                      },
                      model: {
                        value: _vm.formConf.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.formConf, "description", $$v)
                        },
                        expression: "formConf.description",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "questionnaire" },
            [
              _c(
                "draggable",
                {
                  attrs: {
                    animation: 180,
                    list: _vm.drawingList,
                    move: function (event) {
                      return _vm.$emit("move", event)
                    },
                    group: {
                      name: "group_draggable",
                      pull: true,
                      put: ["drawingList"],
                    },
                    handle: ".group_move",
                    "force-fallback": true,
                    scroll: true,
                    "scroll-sensitivity": 160,
                  },
                  on: {
                    start: function ($event) {
                      return _vm.$emit("start")
                    },
                    end: function ($event) {
                      return _vm.onGroupItemEnd($event)
                    },
                    change: function (obj) {
                      return _vm.onDraggableChange(obj, _vm.drawingList)
                    },
                  },
                },
                _vm._l(_vm.drawingList, function (group, groupIndex) {
                  return _c(
                    "div",
                    {
                      key: group.id,
                      staticClass: "drawing_list",
                      attrs: { id: group.formItemGroupId },
                      on: {
                        click: function ($event) {
                          return _vm.activeGroupItem(group)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "question_group_wrap",
                          class:
                            _vm.activeGroupId === group.id ? "selected" : "",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "group-header flex-row align-center",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "group-handle hover_cursor_pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleCollapse(
                                        groupIndex,
                                        !group.collapsed
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fold-button",
                                    class: group.collapsed
                                      ? "el-icon-caret-bottom"
                                      : "el-icon-caret-right",
                                    attrs: { "caret-id": "caret-down-708" },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "ground_name_input_box" },
                                [
                                  _c("el-input", {
                                    ref: "groupNameInput",
                                    refInFor: true,
                                    staticClass: "ground_name_input",
                                    on: {
                                      input: function (val) {
                                        return _vm.handleInputGroupName(
                                          val,
                                          group.formItemGroupId
                                        )
                                      },
                                    },
                                    model: {
                                      value: group.name,
                                      callback: function ($$v) {
                                        _vm.$set(group, "name", $$v)
                                      },
                                      expression: "group.name",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ground_name_input_val",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleFocusInput(
                                            groupIndex
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(group.name) + " ")]
                                  ),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "question_num" }, [
                                _vm._v(
                                  "(共计" + _vm._s(group.items.length) + "题)"
                                ),
                              ]),
                            ]
                          ),
                          group.collapsed
                            ? [
                                _c(
                                  "el-form",
                                  {
                                    attrs: {
                                      "label-position":
                                        _vm.formConf.labelPosition,
                                      "label-width":
                                        _vm.formConf.labelWidth + "px",
                                      size: _vm.formConf.size,
                                    },
                                  },
                                  [
                                    _c(
                                      "draggable",
                                      {
                                        staticClass: "drawing-board",
                                        attrs: {
                                          id: group.formItemGroupId,
                                          list: group.items,
                                          animation: 180,
                                          move: function (event) {
                                            return _vm.$emit("move", event)
                                          },
                                          "force-fallback": true,
                                          scroll: true,
                                          "scroll-sensitivity": 160,
                                          handle: ".move",
                                          group: {
                                            name: "questions-item",
                                            pull: true,
                                            put: true,
                                          },
                                        },
                                        on: {
                                          start: function ($event) {
                                            return _vm.$emit("start")
                                          },
                                          end: function ($event) {
                                            return _vm.$emit(
                                              "onItemEnd",
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._l(
                                          group.items,
                                          function (item, index) {
                                            return _c("form-item-layout", {
                                              key: item.renderKey,
                                              attrs: {
                                                "active-id": _vm.activeId,
                                                "current-item": item,
                                                "drawing-list": group.items,
                                                "form-conf": _vm.formConf,
                                                index: index,
                                              },
                                              on: {
                                                activeItem: function (val) {
                                                  return _vm.$emit(
                                                    "activeFormItem",
                                                    val
                                                  )
                                                },
                                                change: function (currentItem) {
                                                  return _vm.$emit(
                                                    "updateProjectItemInfo",
                                                    currentItem
                                                  )
                                                },
                                                changeLabel: function ($event) {
                                                  return _vm.$emit(
                                                    "changeLabel"
                                                  )
                                                },
                                                copyItem: _vm.drawingItemCopy,
                                                deleteItem:
                                                  _vm.drawingItemDelete,
                                                addInputItem: function (
                                                  currentItem
                                                ) {
                                                  return _vm.$emit(
                                                    "drawingItemAddInputItem",
                                                    currentItem
                                                  )
                                                },
                                                uploadImg: function (
                                                  currentItem
                                                ) {
                                                  return _vm.$emit(
                                                    "uploadImg",
                                                    currentItem
                                                  )
                                                },
                                              },
                                            })
                                          }
                                        ),
                                        !group.items.length
                                          ? _c(
                                              "div",
                                              { staticClass: "empty_info" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "data:image/png;base64,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",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    "从左侧拖入或点选组件进行表单设计"
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "group_bottom hover_cursor_pointer",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-caret-top fold-button",
                                      attrs: { "caret-id": "caret-down-708" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleCollapse(
                                            groupIndex,
                                            false
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "button-area hover_cursor_pointer" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-plus", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.addGroup(groupIndex)
                                },
                              },
                            },
                            [_vm._v("添加题目组")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "operate_list" },
                        _vm._l(_vm.operateList, function (item) {
                          return _c(
                            "el-tooltip",
                            {
                              key: item.icon,
                              attrs: {
                                effect: "dark",
                                content: item.content,
                                placement: "top-start",
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [_vm._v(_vm._s(item.content))]
                              ),
                              _c(
                                "span",
                                {
                                  class: [
                                    "drawing-item__primary drawing-item__" +
                                      item.type +
                                      " group_" +
                                      item.type,
                                    { only_one: _vm.drawingList.length === 1 },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.operateClick(
                                        item.type,
                                        group,
                                        groupIndex
                                      )
                                    },
                                  },
                                },
                                [_c("i", { class: item.icon })]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c("div", { staticClass: "placeholder_box" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }